module.exports = __webpack_public_path__ + "img/16.250f3496.jpg";